import { WSAlert, WSList, WSText } from "@wingspanhq/fe-component-library";
import { validateInsuranceCoverageImportData } from "@wingspanhq/benefits/dist/src/lib/helpers/policyValidation";
import { CollapsibleItem } from "../../../../shared/components/CollapsibleItem/CollapsibleItem";
import { DataViewGrid } from "../../../../shared/components/DataView";
import { IInsuranceCoverageImportData } from "@wingspanhq/benefits/dist/src/lib/interfaces";
import { selectorPolicyTypeByPolicyType } from "../../../MyResources/selectors/selectorPolicyTypeByPolicyType";
import { mapInsuranceCoverageToDataView } from "../../modules/SharedFile/configs/helpers/mapInsuranceCoverageToDataView";

export const Policies: React.FC<{
  policies: IInsuranceCoverageImportData[];
}> = ({ policies }) => {
  return (
    <WSList gap="XL">
      {policies.map((policy, index) => {
        const issues = validateInsuranceCoverageImportData(policy);

        return (
          <CollapsibleItem
            key={index}
            avatarProps={{
              icon: "file",
              type: "icon"
            }}
            title={`Policy ${index + 1}: ${
              policy.title
                ? policy.title
                : selectorPolicyTypeByPolicyType(policy.policyType)
            }`}
            subtitle={
              policy.policyType
                ? selectorPolicyTypeByPolicyType(policy.policyType)
                : undefined
            }
            isExpanded={true}
          >
            {issues.length > 0 ? (
              <WSAlert icon="alert-circle" theme="error" mb="L">
                {issues.map(issue => (
                  <WSText.ParagraphSm key={issue.message} color="gray500">
                    {issue.message}
                  </WSText.ParagraphSm>
                ))}
              </WSAlert>
            ) : (
              <WSAlert icon="check-circle" theme="success" mb="L">
                Policy is ready to be imported.
              </WSAlert>
            )}

            <DataViewGrid
              data={mapInsuranceCoverageToDataView(policy as any)}
            />
          </CollapsibleItem>
        );
      })}
    </WSList>
  );
};
